/**
 * Mixin for employer pages navigation
 */
export default {
  computed: {
    /**
     * Employer action items
     */
    actionItems() {
      return [
        {
          linkPath: this.localePathName('/'),
          title: this.$t('seeker.title'),
        },
        // Map locale link data into item format
        ...this.altLocaleLinks.map((item = {}) => ({
          ...item,
          title: item.titleShort, // Use shortened name
        })),
      ]
    },

    /**
     * Employer page items
     */
    pageItems() {
      return [
        {
          linkPath: this.getArticleLocalePath('employer/solutions'),
          title: this.$t('employer.recruitmentSolutions'),
        },
        {
          linkPath: this.getArticleLocalePath('employer/bidding'),
          title: this.$t('employer.bidding'),
        },
        {
          // Always link to chinese employer blogs list page
          linkPath: this.getArticleLocalePath('employer/blogs/list', this.$i18n.defaultLocale),
          title: this.$t('employer.recruitmentAdvice'),
        },
        {
          linkPath: this.getArticleLocalePath('employer/faq'),
          title: this.$t('employer.faq'),
        },
      ]
    },
  },
}
